import React, { useState } from "react";
import Sidebar from "@/components/crm/Sidebar";
import Topbar from "@/components/crm/Topbar";
import NewLeadPopup from "@/components/crm/NewLeadPopup";

export default function Layout({ title, children }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-cream">
      {/* Desktop sidebar */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {/* Mobile sidebar */}
      {mobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-black/40" onClick={() => setMobileOpen(false)} />
          <div className="absolute left-0 top-0 h-full">
            <Sidebar onNavigate={() => setMobileOpen(false)} />
          </div>
        </div>
      )}

      <div className="flex flex-1 flex-col overflow-hidden">
        <Topbar title={title} onMenuClick={() => setMobileOpen(true)} />
        <main className="flex-1 overflow-y-auto px-4 py-6 md:px-8 md:py-8">
          <div className="animate-fade-up">
            {children}
          </div>
        </main>
      </div>

      {/* In the shell, not on a page: a telecaller sitting on Appointments or
          the WhatsApp inbox still needs to hear about a lead landing in their
          queue. */}
      <NewLeadPopup />
    </div>
  );
}
